import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import axios from "axios";
import "./ideas.css";
import { NavLink } from "react-router-dom";
import ShowMore from "react-show-more";

const IdeaList = () => {
  let [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [ideas, setIdeas] = useState([]);
  const [pages, setPages] = useState({ page: 1, size: 20 });
  const [paging, setPaging] = useState(true);
  const [message, setMessage] = useState({
    type: null,
    text: "",
  });

  const [idea, setIdea] = useState({ link: "" });

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;

    setIdea((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const nextPage = () => {
    loadPaging(pages.page + 1, pages.size);
    setPages((prevState) => {
      return {
        ...prevState,
        page: prevState.page + 1,
      };
    });
  };
  const approveIdea = async (e, itemid) => {
    e.preventDefault();
    let error = false;
    if (idea.remarks === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter remarks.",
        };
      });
      return;
    }
    if (!error) {
      let intitemid = e.target.id.replace("item-", "");
      console.log(intitemid);
      await axios
        .put(
          localStorage.getItem("basurl") + "/ideas/status",
          {
            id: intitemid,
            status: "S",
            remarks: idea.remarks,
          },
          { headers: { "mojo-access-tokens": user.token } }
        )
        .then((response) => {
          loadPaging(pages.page, pages.size);
          idea.remarks = "";
          setMessage(() => {
            return {
              type: "success",
              message: response.data.message,
            };
          });
        })
        .catch((error) => {
          setMessage(() => {
            return {
              type: "danger",
              message: error.response.data.message,
            };
          });
        });
    }
  };

  const rejectIdea = async (e, itemid) => {
    e.preventDefault();
    let error = false;
    if (idea.remarks === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter remarks.",
        };
      });
      return;
    }
    if (!error) {
      let intitemid = e.target.id.replace("itemr-", "");
      console.log(intitemid);
      await axios
        .put(
          localStorage.getItem("basurl") + "/ideas/status",
          {
            id: intitemid,
            status: "R",
            remarks: idea.remarks,
          },
          { headers: { "mojo-access-tokens": user.token } }
        )
        .then((response) => {
          loadPaging(pages.page, pages.size);
          setMessage(() => {
            return {
              type: "success",
              message: response.data.message,
            };
          });
        })
        .catch((error) => {
          setMessage(() => {
            return {
              type: "danger",
              message: error.response.data.message,
            };
          });
        });
    }
  };
  const resetMessage = (e) => {
    setMessage(() => {
      return {
        type: null,
        message: "",
      };
    });
  };
  const getMessage = () => {
    if (message.type) {
      return (
        <div className={`alert alert-${message.type}`} role="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong className="d-block d-sm-inline-block-force">
            {message.type === "success" ? "Well done!" : "Oops!"}
          </strong>{" "}
          {message.message}
        </div>
      );
    }
  };

  const loadPaging = async (page, size = pages.size) => {
    let user = JSON.parse(localStorage.getItem("user"));
    try {
      await axios
        .get(
          localStorage.getItem("basurl") +
            "/ideas?page=" +
            page +
            "&size=" +
            size,
          {
            headers: {
              "mojo-access-tokens": user.token,
            },
          }
        )
        .then((response) => {
          setIdeas((prevState) => {
            prevState.push.apply(prevState, response.data);
            return response.data;
          });
          if (response.data.length < size) {
            setPaging(false);
          }
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadPaging(1);
  }, []);

  return (
    <>
      <div className="mg-t-10">
        {getMessage()}
        <>
          {ideas.length ? (
            ideas.map((item) => (
              <div key={`media${item.id}`} className="media pd-5 pd-xs-5">
                {user.profile_pic ? (
                  <>
                    <img
                      src={`${localStorage.getItem("basurl")}/uploads/${
                        user.profile_pic
                      }`}
                      alt="User"
                      className="wd-40 rounded-circle"
                    />
                  </>
                ) : (
                  <>
                    <span
                      className="wd-32 rounded-circle tx-bold tx-16"
                      style={{ border: "1px solid #ccc", padding: "3px 11px" }}
                    >
                      {item.createdby.charAt(0).toUpperCase()}
                    </span>
                  </>
                )}
                <div key={item.id} className="media-body mg-l-5">
                  <div className="d-flex justify-content-between mg-b-5 tx-12 tx-info">
                    {user.isadmin === 1 ? (
                      <span>
                        {item.createdby}: {item.city} ({item.state})
                      </span>
                    ) : (
                      ""
                    )}
                    <span className="ft-right">
                      <Moment date={item.created_at1} local fromNow />
                    </span>
                  </div>

                  <p
                    className={
                      "mg-b-10 display-linebreak tx-15 mg-t-10 " +
                      (item.status === "S"
                        ? "tx-success"
                        : item.status === "R"
                        ? "tx-danger"
                        : "tx-warning")
                    }
                  >
                    <ShowMore lines={2} more="Show more" less="Show less">
                      {item.description}
                    </ShowMore>
                  </p>
                  <div className="media-footer">
                    <div>
                      {item.status === "P" && item.created_by === user.id ? (
                        <NavLink
                          to={`/ideas/update-idea/${item.id}`}
                          className="mg-r-10 tx-12"
                        >
                          <i className="ion-compose"></i> Edit Idea
                        </NavLink>
                      ) : (
                        ""
                      )}
                      {item.status !== "P" ? (
                        <span className="tx-10 mg-r-10">
                          <b>
                            {item.status === "R" ? "Rejected " : ""}
                            {item.status === "S" ? "Approved " : ""}
                          </b>
                          &nbsp;by <b>{item.statusby}</b>
                          <Moment
                            className="mg-x-10"
                            date={item.status_at1}
                            local
                            fromNow
                          />
                          |<b className="mg-l-10">Remarks:</b>{" "}
                          <span className=" pd-x-4">{item.remarks}</span>
                        </span>
                      ) : (
                        ""
                      )}

                      <div className="ft-right tx-20">
                        {(item.status === "P" && user.isadmin === 1) ||
                        user.language_code === "gu" ? (
                          <div>
                            <input
                              type="text"
                              name="remarks"
                              onFocus={resetMessage}
                              className="tx-12 mg-x-5"
                              placeholder="Enter remarks"
                              defaultValue={item.remarks}
                              onChange={handleChange}
                            />
                            <i
                              className="tx-success mg-x-5 ion-android-checkbox-outline"
                              id={`item-${item.id}`}
                              onClick={approveIdea}
                            ></i>
                            <i
                              className="tx-danger mg-x-5 ion-close-round"
                              id={`itemr-${item.id}`}
                              onClick={rejectIdea}
                            ></i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="media pd-20 pd-xs-30">
              <span className="tx-center">
                You have not added any idea yet.
              </span>
            </div>
          )}
        </>
        <div className="card-footer tx-10 pd-y-15 bg-transparent tx-center">
          {paging ? (
            <h4 onClick={nextPage} href="#" className="pointer tx-16">
              <i className="fa fa-angle-down mg-r-5" />
              View More
            </h4>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};
//<i className=" tx-18 tx-danger mg-x-5 ion-close-round" onClick={deleteIdea}></i>
export default IdeaList;
